// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"09220e82","239":"2864f018","455":"87e276af","488":"276c6397"}[chunkId] + ".chunk.js";
};